import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { Dealer } from 'app/core/model/dealer';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DealerEntryDialogComponent } from '../dealer-entry-dialog/dealer-entry-dialog.component';
import { Response } from 'app/core/response';

@Component({
    selector: 'app-dealer-entry',
    templateUrl: './dealer-entry.component.html',
    styleUrls: ['./dealer-entry.component.scss'],
    standalone: false
})
export class DealerEntryComponent implements OnInit {
    dealers: Dealer[];

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.dealers = await this.uow.getDealerEntries();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async rowPrepare(e) {
        if (e.rowType !== 'data' || !e.data) return;

        const dealer = e.data as Dealer;
        if (dealer.validated) {
            e.rowElement.className = e.rowElement.className + ' dealer-entry-validated';
        } else if (dealer.sent >= moment(new Date()).startOf('day').add(-3, 'days').toDate()) {
            e.rowElement.className = e.rowElement.className + ' dealer-entry-sent';
        } else if (dealer.sent) {
            e.rowElement.className = e.rowElement.className + ' dealer-entry-expired';
        }
    }

    async rowDoubleClick(e) {
        if (e.data) this.open(e.data);
    }

    async open(dealer?: Dealer) {
        const modalRef = this.modalService.show(DealerEntryDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dealer: dealer,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && result.dealer) {
                if (result.send) await this.send(result.dealer, false);
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
            await this.getData();
        });
    }

    async delete(dealer: Dealer) {
        const success = await confirm('Are you sure you want to DELETE this dealer?', this.appInfo.settings.company);
        if (!success) return;

        dealer.deleted = new Date();
        await this.uow.commit([dealer]);
        await this.getData();
    }

    async send(dealer: Dealer, showAlert: boolean = true) {
        if (showAlert) {
            const success = await confirm('Are you sure you want to email this dealer?', this.appInfo.settings.company);
            if (!success) return;
        }

        this.appInfo.pleaseWaitShow();
        if (!dealer.code) {
            dealer.code = crypto.randomUUID();
            await this.uow.commit([dealer]);
        }
        const response = await this.utility.emailDealerEntry(dealer.id);
        if (response.success) {
            dealer.sent = new Date();
            await this.uow.commit([dealer]);
            await alert('Email Sent!', this.appInfo.settings.company);
        } else await alert(`Failed to send email to ${dealer.portalEmail}.\n ${response.message}`, this.appInfo.settings.company);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async resetLink(dealer: Dealer) {
        if (dealer.isValidated) {
            const success = await confirm('Are you sure you want to reset the link? \nThis dealer has already been validated.', this.appInfo.settings.company);
            if (!success) return;
        }
        dealer.sent = new Date();
        await this.uow.commit([dealer]);
    }
}
